import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Dropdown} from "primereact/dropdown";
import {Column} from "primereact/column";
import {DataTable} from 'primereact/datatable';
import axios from "axios";
import {BlockUI} from "primereact/blockui";

const PurchaseorderitemDndComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [formData, setFormData] = useState({});
  const [requests, setRequests] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [draggingRequestIds, setDraggingRequestIds] = useState([]);
  const [dragOverOrderTable, setDragOverOrderTable] = useState(false);

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const [selectedRequests, setSelectedRequests] = useState([]);
  const poId = (window.App.urlVars()?.purchaseorderId ?? id);
  const hasValidPoId = poId && poId !== 'undefined' && poId !== 'create';

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    const projectId = formData?.project?.id;
    if (!projectId) return;
    setLoadingRequests(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      const url = '/api/v2/purchase-order-request-item' + query + 
                  '&search[status][operator]==&search[status][value]=DONE&search[project][operator]==&search[project][value]=' + projectId;

      apiCall('GET', url)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setRequests(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingRequests(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const [totalRecordsItems, setTotalRecordsItems] = useState(0);
  const [rowsItems, setRowsItems] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dtItems = useRef(null);
  const [lazyParamsItems, setLazyParamsItems] = useState({
    first: 0,
    rows: rowsItems,
    page: 0,
    sortField: 'position',
    sortOrder: 1,
    filters: {
      purchase_order: {value: id, matchMode: 'equals'}
    }
  });

  let loadLazyTimeoutItems = null;
  const loadLazyDataItems = () => {
    setLoadingItems(true);
    if (loadLazyTimeoutItems) {
      clearTimeout(loadLazyTimeoutItems);
    }
    loadLazyTimeoutItems = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParamsItems)
      apiCall('GET', '/api/v2/purchase-order-item' + query)
        .then(response => {
          setTotalRecordsItems(response.data.data.total_item_count);
          setItems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingItems(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPageItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onSortItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    setLazyParamsItems(_lazyParams);
  }
  const onFilterItems = (event) => {
    let _lazyParams = {...lazyParamsItems, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsItems(_lazyParams);
  }
  const pagerItems = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRowsItems(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const handleDragStart = (event, item) => {
    if (formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED') {
      return;
    }
    let draggedItems = [item];
    if (Array.isArray(selectedRequests) && selectedRequests.length > 0) {
      const isPartOfSelection = selectedRequests.some(sel => sel.id === item.id);
      if (isPartOfSelection) {
        draggedItems = selectedRequests;
      }
    }
    const draggedIds = draggedItems.map(i => i.id);
    const payload = {
      source: 'purchase-order-request-items',
      ids: draggedIds,
    };
    setDraggingRequestIds(draggedIds);
    event.dataTransfer.setData("application/json", JSON.stringify(payload));
    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragEnd = () => {
    setDraggingRequestIds([]);
    setDragOverOrderTable(false);
  };

  const renderDraggableCell = (content, rowData) => (
    <div
      draggable={!(formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED')}
      onDragStart={(e) => handleDragStart(e, rowData)}
      onDragEnd={handleDragEnd}
      style={{
        cursor:
          formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED'
            ? 'default'
            : 'move'
      }}
    >
      {content}
    </div>
  );

  const handleDrop = async (event, target) => {
    event.preventDefault();
    setDragOverOrderTable(false);
    if (target === "right") {
      let raw =
        event.dataTransfer.getData("application/json") ||
        event.dataTransfer.getData("text/plain");
      if (!raw) return;

      let payload = null;
      try {
        payload = JSON.parse(raw);
      } catch (e) {
        return;
      }
      let ids = [];
      if (payload && Array.isArray(payload.ids)) {
        ids = payload.ids;
      } else if (payload && payload.id) {
        ids = [payload.id];
      } else if (Array.isArray(payload)) {
        ids = payload;
      }
      if (!ids || ids.length === 0) return;
      const itemsToAdd = requests.filter(r => ids.includes(r.id)).reverse();
      if (itemsToAdd.length === 0) return;
      const delay = (ms) => new Promise(res => setTimeout(res, ms));
      setLoading(true);
      try {
        for (let i = 0; i < itemsToAdd.length; i++) {
          const droppedItem = itemsToAdd[i];
          await apiCall('post', '/api/v2/purchase-order-item', {
            purchase_order: Number(id),
            purchase_order_request_item: droppedItem.id,
          });
          if (i < itemsToAdd.length - 1) {
            await delay(10);
          }
        }
        window.App.toastShow('success', 'Sikeres mentés!');
        setLazyParamsItems({
          first: 0,
          rows: rowsItems,
          page: 0,
          sortField: 'id',
          sortOrder: -1,
          filters: {
            purchase_order: { value: id, matchMode: 'equals' }
          }
        });
        window.App.setState({
          rerenderPurchaserequestItems: Date.now(),
          rerenderPurchaseorderItems: Date.now(),
          rerenderProcurementPage: Date.now(),
        });
      } catch (error) {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      } finally {
        setLoading(false);
        setDraggingRequestIds([]);
        setDragOverOrderTable(false);
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    //console.log(handleDragOver)
  };

  // useEffect(() => {
  //   loadLazyData()
  // }, [lazyParams, window.App.state.rerenderPurchaserequestItems, window.App.state.rerenderPurchaseorderItems])

  useEffect(() => {
    if (id) {
      loadLazyDataItems()
    }
  }, [lazyParamsItems, window.App.state.rerenderPurchaserequestItems, window.App.state.rerenderPurchaseorderItems])

  useEffect(() => {
    if (window.App.urlVars().materialId) {
      setLoading(true)
      apiCall('post', '/api/v2/purchase-order-item', {
        purchase_order: Number(id),
        purchase_order_request_item: window.App.urlVars().requestItemId,
        substitution_material: window.App.urlVars().materialId
      })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          history.push('/procurement/' + entity + '/' + action + '/' + id)
          loadLazyDataItems()
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [window.App.urlVars().materialId])

  useEffect(() => {
    loadLazyData()
  }, [lazyParams, formData?.project?.id, window.App.state.rerenderPurchaserequestItems, window.App.state.rerenderPurchaseorderItems])

  useEffect(() => {
    // if ((!window.App.urlVars().create && window.App.urlVars().purchaseorderId) || (entity === 'purchase-order' && id)) {
    //   setLoading(true);
    //   apiCall('get', '/api/v2/purchase-order/' + (window.App.urlVars().purchaseorderId ?? id))
    if (hasValidPoId) {
      setLoading(true);
      apiCall('get', '/api/v2/purchase-order/' + (window.App.urlVars().purchaseorderId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [window.App.state.rerenderPurchaserequestDnd])

  return (
    <div className={"purchaserequest-dnd widget"}>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-8"}
             onDragOver={handleDragOver}
             onDrop={(e) => handleDrop(e, "left")}
        >
          <Panel>
            {/*{loadingRequests &&*/}
            {/*  <ProgressBar mode="indeterminate"*/}
            {/*               style={{*/}
            {/*                 height: '5px',*/}
            {/*                 position: "absolute",*/}
            {/*                 top: '-12px',*/}
            {/*                 left: 0,*/}
            {/*                 borderRadius: 0,*/}
            {/*               }}></ProgressBar>*/}
            {/*}*/}
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('requestedProducts')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              </div>
            </div>
            <BlockUI
              blocked={(formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED')}>
              <DataTable
                emptyMessage={t('noResults')}
                size={"small"}
                value={requests} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                onFilter={onFilter} filters={lazyParams.filters} lazy
                paginatorTemplate={pager} rows={rows}
                autoLayout={true}
                filterDisplay="none"
                responsiveLayout="scroll"
                stripedRows
                ref={dt}
                dataKey="id"
                loading={loadingRequests}
                selection={selectedRequests}
                onSelectionChange={e => setSelectedRequests(e.value)}
                rowClassName={(rowData) =>
                  Array.isArray(draggingRequestIds) && draggingRequestIds.includes(rowData.id)
                    ? 'dnd-drag-source-row-active'
                    : 'dnd-drag-source-row'
                }
              >
                <Column
                  selectionMode="multiple"
                  headerStyle={{ width: '3rem' }}
                />
                <Column
                  header={t('columnPurchaseRequestNumber')}
                  sortable
                  filter
                  body={(rowData) => {
                    const value = rowData?.purchase_order_request?.purchase_order_request_number;
                    return renderDraggableCell(value, rowData);
                  }}
                />
                <Column field="purchase_order_request.project.name" header={t('columnProject')} sortable filter></Column>
                <Column field="name" header={t('columnName')} sortable filter
                        body={(rowData) => renderDraggableCell(rowData?.material?.name, rowData)}
                ></Column>
                <Column field="upc" header={t('upc')} sortable filter
                        body={(rowData) => renderDraggableCell(rowData?.material?.upc, rowData)}
                ></Column>
                <Column field="quantity" header={t('columnQuantity')} sortable filter className={"p-text-right"}
                        body={(rowData) => renderDraggableCell(`${Number(rowData?.quantity)} ${rowData?.unit?.name || ''}`, rowData)}
                ></Column>
                <Column field="substitution_type.name" header={t('columnSubstitutionReason')} sortable filter
                        body={(rowData) => renderDraggableCell(rowData?.substitution_type?.name, rowData)}
                ></Column>
              </DataTable>
            </BlockUI>
          </Panel>
        </div>
        <div
          className={"p-col-12 p-lg-4"}
          onDragOver={(e) => {
            e.preventDefault();
            if (draggingRequestIds.length > 0) {
              setDragOverOrderTable(true);
            }
          }}
          onDragLeave={(e) => {
            const related = e.relatedTarget;
            if (!e.currentTarget.contains(related)) {
              setDragOverOrderTable(false);
            }
          }}
          onDrop={(e) => handleDrop(e, "right")}
        >
          <Panel>
            {/*{loadingItems &&*/}
            {/*  <ProgressBar mode="indeterminate"*/}
            {/*               style={{*/}
            {/*                 height: '5px',*/}
            {/*                 position: "absolute",*/}
            {/*                 top: '-12px',*/}
            {/*                 left: 0,*/}
            {/*                 borderRadius: 0,*/}
            {/*               }}></ProgressBar>*/}
            {/*}*/}
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {t('orderItems')}
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
              </div>
            </div>
            <BlockUI
              blocked={(formData.status === 'ORDERED' || formData.status === 'DELETED' || formData.status === 'CLOSED')}>
              <DataTable
                emptyMessage={t('noResults')}
                size={"small"}
                value={items} paginator first={lazyParamsItems.first} totalRecords={totalRecordsItems}
                onPage={onPageItems}
                onSort={onSortItems} sortField={lazyParamsItems.sortField} sortOrder={lazyParamsItems.sortOrder}
                onFilter={onFilterItems} filters={lazyParamsItems.filters} lazy
                paginatorTemplate={pagerItems} rows={rowsItems}
                autoLayout={true}
                filterDisplay="none"
                responsiveLayout="scroll"
                stripedRows
                ref={dtItems}
                dataKey="id"
                loading={loadingItems}
              >
                {/* <Column field="purchase_order.purchase_order_number" header={t('columnPurchaseRequestNumber')}
                          sortable filter></Column> */}
                <Column field="material.name" header={t('columnName')} sortable filter></Column>
                <Column field="material.upc" header={t('upc')} sortable filter></Column>
                <Column header={t('columnQuantity')} sortable filter className={"p-text-right"} body={(rowData) => {
                  if(rowData.quantity) {
                    return (
                      <>
                        {Number(rowData?.quantity)} {rowData?.unit?.name}
                      </>
                    )
                  }
                }}></Column>
              </DataTable>
            </BlockUI>
          </Panel>
        </div>
      </div>
    </div>
  )
}
export default withTranslation('common')(PurchaseorderitemDndComponent);
